module.exports = __webpack_public_path__ + "img/2.8689a215.jpg";